import React from "react";

const HeadsetIcon: React.FC = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.1406 11.9998H18.1406C17.7428 11.9998 17.3613 12.1579 17.08 12.4392C16.7987 12.7205 16.6406 13.102 16.6406 13.4998V17.2498C16.6406 17.6476 16.7987 18.0292 17.08 18.3105C17.3613 18.5918 17.7428 18.7498 18.1406 18.7498H19.6406C20.0384 18.7498 20.42 18.5918 20.7013 18.3105C20.9826 18.0292 21.1406 17.6476 21.1406 17.2498V11.9998ZM21.1406 11.9998C21.1407 10.8116 20.9054 9.63511 20.4484 8.53826C19.9915 7.44141 19.3218 6.44591 18.4781 5.6092C17.6344 4.77248 16.6334 4.11112 15.5328 3.66326C14.4322 3.2154 13.2538 2.98992 12.0656 2.99982C10.8782 2.99117 9.70083 3.21757 8.60132 3.66598C7.5018 4.1144 6.50189 4.77596 5.6592 5.61255C4.81651 6.44914 4.1477 7.44422 3.69131 8.54045C3.23492 9.63668 2.99997 10.8124 3 11.9998V17.2498C3 17.6476 3.15804 18.0292 3.43934 18.3105C3.72064 18.5918 4.10218 18.7498 4.5 18.7498H6C6.39782 18.7498 6.77936 18.5918 7.06066 18.3105C7.34196 18.0292 7.5 17.6476 7.5 17.2498V13.4998C7.5 13.102 7.34196 12.7205 7.06066 12.4392C6.77936 12.1579 6.39782 11.9998 6 11.9998H3"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.1406 17.25V19.5C21.1406 20.2956 20.8246 21.0587 20.2619 21.6213C19.6993 22.1839 18.9363 22.5 18.1406 22.5H12.75"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default HeadsetIcon;
